
define('ldsh!modules/form_editor/templates/custom_privacy', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (labelVisible) { ;
__p += '\n  <label class="col-sm-12">' +
((__t = ( labelText )) == null ? '' : __t) +
'</label>\n';
 } ;
__p += '\n<p class="col-sm-12">' +
((__t = ( informationTextParsed )) == null ? '' : __t) +
'</p>\n<div class="col-sm-12 js-control js-items"></div>\n\n';
 if (isAMP) { ;
__p += '\n<span class="hidden-no-amp"\n  validation-for="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'-anythingChecked"\n  visible-when-invalid="valueMissing">' +
((__t = (errorMessage)) == null ? '' : __t) +
'</span>\n\n<input id="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'-anythingChecked"\n  value="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'"\n  type="checkbox"\n  data-amp-state-id="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'"\n  data-amp-state-content=\'{"choiceChecked": 0}\'\n  [checked]="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'.choiceChecked > 0 ? \'checked\' : \'\'"\n  style="display:none"\n' +
((__t = ( isRequired ? 'required' : '' )) == null ? '' : __t) +
'\n/>\n';
 } ;
__p += '\n\n<div class="col-sm-12">&nbsp;</div>\n';

}
return __p
};});

